import React, { FC } from 'react'
import {
  BarFill,
  BarHeader,
  BarLabel,
  BarRow,
  BarTrack,
  BarValue,
  BarsWrap,
  EmptyState,
} from './styles'

export interface PaymentBarItem {
  label: string
  percentual: number
  quantidade?: number
  color?: string
}

const COLORS = [
  '#101828',
  '#344054',
  '#475467',
  '#667085',
  '#98A2B3',
  '#D0D5DD',
]

/** Distribuição por forma de pagamento em barras horizontais com % e quantidade. */
const PaymentBars: FC<{ items: PaymentBarItem[] }> = ({ items }) => {
  if (!items.length) {
    return <EmptyState>Sem vendas no período selecionado.</EmptyState>
  }

  return (
    <BarsWrap>
      {items.map((item, i) => (
        <BarRow key={`${item.label}-${i}`}>
          <BarHeader>
            <BarLabel>{item.label}</BarLabel>
            <BarValue>
              {item.quantidade != null ? `${item.quantidade} · ` : ''}
              {item.percentual}%
            </BarValue>
          </BarHeader>
          <BarTrack>
            <BarFill
              style={{
                width: `${Math.min(Number(item.percentual) || 0, 100)}%`,
                background: item.color ?? COLORS[i % COLORS.length],
              }}
            />
          </BarTrack>
        </BarRow>
      ))}
    </BarsWrap>
  )
}

export default PaymentBars
